import { useEffect, useState } from 'react';

const links = [
  { label: 'Our Brands', href: '#brands' },
  { label: 'About', href: '#about' },
  { label: 'Partnerships', href: '#partnerships' },
  { label: 'Careers', href: '#careers' },
  { label: 'Contact', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const linkColor = scrolled ? 'text-foreground-700' : 'text-background-50/85';
  const logoColor = scrolled ? 'text-foreground-950' : 'text-background-50';
  const logoSub = scrolled ? 'text-foreground-500' : 'text-background-50/70';

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur border-b border-background-200' : 'bg-transparent'
      }`}
    >
      <nav className="flex items-center justify-between h-20 px-6 md:px-10">
        <a href="#top" className="flex flex-col leading-none cursor-pointer">
          <span className={`font-heading text-[22px] font-semibold tracking-[0.08em] ${logoColor} transition-colors`}>
            JEDL
          </span>
          <span className={`text-[9px] uppercase tracking-[0.42em] mt-1 ${logoSub} transition-colors`}>
            Restaurants
          </span>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className={`text-sm ${linkColor} hover:text-primary-600 transition-colors whitespace-nowrap`}
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            className={`whitespace-nowrap px-5 py-2.5 rounded-md text-sm transition-colors ${
              scrolled
                ? 'bg-foreground-950 text-background-50 hover:bg-foreground-800'
                : 'bg-background-50 text-foreground-950 hover:bg-background-100'
            }`}
          >
            Get in Touch
          </a>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          className={`md:hidden w-10 h-10 flex items-center justify-center ${logoColor}`}
          aria-label="Toggle menu"
          aria-expanded={open}
        >
          <i className={`text-2xl ri-${open ? 'close' : 'menu'}-line`}></i>
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-6 py-5 flex flex-col gap-1">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-base py-2.5 text-foreground-900 border-b border-background-100"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="mt-4 text-center px-5 py-3 rounded-md bg-foreground-950 text-background-50 text-sm"
          >
            Get in Touch
          </a>
        </div>
      )}
    </header>
  );
}